import React, { Component } from 'react';
import { Loading } from './../../common';
import FontAwesome from 'react-fontawesome';
import './PlayerAvatar.css';

class PlayerAvatar extends Component {
	constructor(props) {
		super(props);
		this.state = { imageLoading: true, imageLoadingError: false };
	}

	handleImageLoaded() {
		this.setState({ imageLoading: false, imageLoadingError: false });
	}

	handleImageErrored() {
		this.setState({ imageLoading: false, imageLoadingError: true });
	}
	_renderPlace = () => (this.state.imageLoading ? <div className="imagePlace" /> : null);
	_renderImage = () => (
		<img
			className={this.state.imageLoading ? 'hideIm2g' : 'player-avatar fadeIn'}
			title={this.props.firstName + ' ' + this.props.surname}
			alt={this.props.surname}
			src={this.props.avatar}
			onLoad={this.handleImageLoaded.bind(this)}
			onError={this.handleImageErrored.bind(this)}
		/>
	);

	render() {
		return (
			<div>
				{this._renderPlace()}
				{this._renderImage()}
			</div>
		);
	}
}

export { PlayerAvatar };



// WEBPACK FOOTER //
// ./src/components/cards/playerAvatar/PlayerAvatar.js